import { Component, OnInit } from '@angular/core';
import {ApprovalModel} from '../../../shared/dto/approval.model';
import {UserRoleEnum} from '../../../shared/enums/user-role.enum';
import {ActivatedRoute} from '@angular/router';
import {RemarkComponent} from '../../../approval-process/remark/remark.component';
import {BlacklistApproveChecklistComponent} from '../../../blacklist-process/blacklist-approve-checklist/blacklist-approve-checklist.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ReturnRemarkComponent} from '../../../approval-process/return-remark/return-remark.component';
import {ReversedReturnRequestComponent} from '../../../reversed-blacklist-process/reversed-process-verification/reversed-blacklist-verification-request-viewer/reversed-return-request/reversed-return-request.component';
import {TokenStorageService} from '../../../shared/service/token-storage.service';
import {FwdRemarkComponent} from '../../../approval-process/fwd-remark/fwd-remark.component';
import {WorkflowStageEnum} from '../../../shared/enums/workflow-stage.enum';
import {ApprovalService} from '../../../service/approval.service';
import {ActionMode} from '../../../shared/enums/action-mode.enum';
import {WorkflowEnum} from '../../../shared/enums/workflow.enum';

@Component({
  selector: 'app-reversed-suspend-verification-request-viewer',
  templateUrl: './reversed-suspend-verification-request-viewer.component.html',
  styleUrls: ['./reversed-suspend-verification-request-viewer.component.scss']
})
export class ReversedSuspendVerificationRequestViewerComponent implements OnInit {
  appRefNo: number;
  userName: string;
  types: string;
  userRole: string;
  type: string;
  DG:string = UserRoleEnum.DG;
  SHO:string = UserRoleEnum.SHO;
  EXM:string = UserRoleEnum.EXM;
  approvalModel: ApprovalModel = new ApprovalModel();

  constructor(private route: ActivatedRoute, private tokenStorageService: TokenStorageService,
              private approvalService: ApprovalService, private modalService: NgbModal) {
    this.route.paramMap.subscribe(params => {
      this.appRefNo = +this.decodeBase64(params.get('id'));
      this.types = WorkflowStageEnum.SID_DG_BLK_APR;
    });
  }

  ngOnInit() {
    this.userName=this.tokenStorageService.getUserObjectToken().username;
    this.userRole=this.tokenStorageService.getUserObjectToken().userroleCode;
  }
  decodeBase64(code: string): string {
    return atob(code);
  }

  rejectRequest() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'Reject';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(RemarkComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService)
  }

  forwardToDg() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'FWD_DG';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(FwdRemarkComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService)
  }

  returnRequest() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'RETURN';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(ReturnRemarkComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService);
  }

  approveRequest() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = ActionMode.APPROVE;
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;
    this.approvalModel.stage = WorkflowEnum.SUSPEND_REVERSED;

    const modalRef = this.modalService.open(BlacklistApproveChecklistComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService);
  }

  returnBlacklist() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = ActionMode.RETURN;
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(ReversedReturnRequestComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService);
  }

}
